import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

import CategoriesPanel from "./CreateItemDialog/CategoriesPanel"
import ShopPanel from './CreateItemDialog/ShopPanel'

import SelectShopDialog from '../../shop/SelectShopDialog'

/**
 * <CreateItemDialog selected onCreateItem = {item} onCancel = {} />
 */

class CreateItemDialog extends Component {

	state = {
		name: "",
		code: "",
		categories: [],
		shops: [],
		dialog: undefined,
	}

	isReadyToCreate() {
		return this.state.name !== ""
	}

	getFolderId = selected => selected ? (selected.type.toString() === "0" ? selected.id : selected.folder_id ): "0"

	render() {

		if (this.state.dialog) {
			return this.state.dialog
		}

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Создать предмет
			</DialogTitle>

			<DialogContent style = {{display: "flex", flexDirection: "column"}}>

				<CategoriesPanel
					title = "Категории"
					parent = {this}
					categories = {this.state.categories}
					onAttachCategory = {category => {
						this.state.categories.push(category)
						this.forceUpdate()
					}}
					onDetachCategory = {category => {
						this.setState({
							categories: this.state.categories.filter(c => c !== category)
						})
					}}
				/>

				<ShopPanel
					title = "Магазины"
					shops = {this.state.shops}
					onAttachShopClick = {() => {
						this.setState({
							dialog: <SelectShopDialog 
								hideNoShop
								hideShops = {this.state.shops}
								onSelectClick = {(shop) => {
									if (!shop) {
										return
									}
									this.setState({dialog: undefined}, () => {
										if (!this.state.shops.find(s => s.id === shop.id)) {
											this.state.shops.push(shop)
											this.setState({shops: this.state.shops})
										}
									})
								}}
								onCancelClick = {() => {this.setState({dialog: undefined})}}
							/>
						})
					}}
					onDetachShopClick = {(shop) => {
						this.setState({
							shops: this.state.shops.filter((s) => s.id !== shop.id)
						})
					}}
				/>

				<TextField
					value = {this.state.name}
					label = "Название предмета"
					margin = "normal"
					onChange = {e => {
						this.setState({
							name: e.target.value
						})
					}}
				/>

				<TextField
					value = {this.state.code}
					label = "Поисковый код"
					margin = "normal"
					onChange = {e => {
						this.setState({
							code: e.target.value
						})
					}}
				/>

			</DialogContent>

			<DialogActions>

				<Button
					disabled = {!this.isReadyToCreate()}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCreateItem === "function") {
							this.props.onCreateItem({
								name: this.state.name,
								code: this.state.code,
								categories: this.state.categories,
								shops: this.state.shops,
								type: "1",
								folderId: this.getFolderId(this.props.selected),
							})
						}
					}}
				>Создать</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default CreateItemDialog
